import { render, staticRenderFns } from "./OrderDetailsSummary.vue?vue&type=template&id=7108c47c&"
import script from "./OrderDetailsSummary.vue?vue&type=script&lang=js&"
export * from "./OrderDetailsSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports